// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export function logError(...args: any[]) {
  // eslint-disable-next-line no-console
  console.error(...args);
}
